import React from "react";
import Certificate from "../../components/Containers/Certificate";

const ExternalCertificate = (props) => {
  return <Certificate external certificateId={props.match.params.id} />;
};

export default ExternalCertificate;
